<template>
  <router-link
    class="searchLink"
    :to="{ name: 'search', params: { lang: language } }"
    :title="$t('NAV_SEARCH')"
    :aria-label="$t('NAV_SEARCH')"
  >
    <Icon class="searchIcon" icon="search" width="16" />
  </router-link>
</template>

<script>
import { mapState } from 'vuex';
import Icon from '../Icon.vue';

export default {
  name: 'SearchMenuItem',
  components: { Icon },
  computed: {
    ...mapState({
      language: (state) => state.language,
    }),
  },
};
</script>

<style lang="scss" scoped>
.searchLink {
  display: inline-flex;
  align-items: center;
  line-height: 1;
}
</style>
